/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services')
    .factory('Loader', ["$log", "$timeout", "$http", "VatSrv", "OtherPaymentTypeSrv", "SiteSrv", "HumanResourceSrv", "PhysicalResourceSrv", "CategorySrv", "ProductCategorySrv", "CureCategorySrv", "LoyaltyCardCategorySrv", "ServiceSrv",
        "ProductSrv", "CureSrv", "LoyaltyCardSrv", "CustomerSrv", "SupplierSrv", "ImageSrv", "Site", "HumanResource", "PhysicalResource", "Category", "ProductCategory", "CureCategory", "Image", "CompanyImageSrv", "CompanyImage",
        "CompanyImageData", "SaleSrv", "SaleData", "BookingSrv", "BookingData", "AppSrv", "App", "UserSrv", "StoreAppSrv", "CompanySrv", "CategoryData", "DaySrv", "DayData", "SiteData", "ImageData", "CureItemToServiceSrv",
        "CureItemToServiceUsageSrv", "Vat", "OrderSrv", "UsageProductSrv", "CheckDepositSrv", "ProductCategoryData", "CureCategoryData", "LoyaltyCardCategoryData", "LoyaltyCardCategory", "CustomerData",
        "AuditTrailSrv", "ReportModelSrv", "CurrencySrv", "CustomerPost", "CustomerPostData", "MeasureStore", "TimeMeasures", "Decorators", "CountMeasures", "ActivityData", "LanguageManager", "LaunchDarklyFeatureFlagData", "$location", "Constants",
        "LoaderUtil", "MonitoringSrv", "MonitoringApplication", "MonitoringHealthState", "OfferService", "DayHrData", "DayPrData", "SaleServiceData", "SaleProductData",
        "SaleCureData", "GiftItemData", "LoyaltyCardItemData", "CheckDepositData", "CompanyMigrationSettingsSrv",
        function ($log, $timeout, $http, VatSrv, OtherPaymentTypeSrv, SiteSrv, HumanResourceSrv, PhysicalResourceSrv, CategorySrv, ProductCategorySrv, CureCategorySrv, LoyaltyCardCategorySrv, ServiceSrv,
                  ProductSrv, CureSrv, LoyaltyCardSrv, CustomerSrv, SupplierSrv, ImageSrv, Site, HumanResource, PhysicalResource, Category, ProductCategory, CureCategory, Image, CompanyImageSrv, CompanyImage,
                  CompanyImageData, SaleSrv, SaleData, BookingSrv, BookingData, AppSrv, App, UserSrv, StoreAppSrv, CompanySrv, CategoryData, DaySrv, DayData, SiteData, ImageData, CureItemToServiceSrv,
                  CureItemToServiceUsageSrv, Vat, OrderSrv, UsageProductSrv, CheckDepositSrv, ProductCategoryData, CureCategoryData, LoyaltyCardCategoryData, LoyaltyCardCategory, CustomerData,
                  AuditTrailSrv, ReportModelSrv, CurrencySrv, CustomerPost, CustomerPostData, MeasureStore, TimeMeasures, Decorators, CountMeasures, ActivityData, LanguageManager, LaunchDarklyFeatureFlagData, $location, Constants,
                  LoaderUtil, MonitoringSrv, MonitoringApplication, MonitoringHealthState, OfferService, DayHrData, DayPrData, SaleServiceData, SaleProductData,
                  SaleCureData, GiftItemData, LoyaltyCardItemData, CheckDepositData, CompanyMigrationSettingsSrv) {

            const useHashMapForApplicationLoading = true;
            let loader = {
                loggedUserLoading: false,
                storeAppLoading: false,
                vatsLoading: false,
                optsLoading: false,
                sitesLoading: false,
                humanResourcesLoading: false,
                physicalResourcesLoading: false,
                categoriesLoading: false,
                productCategoriesLoading: false,
                productLoading: false,
                cureCategoriesLoading: false,
                cureLoading: false,
                loyaltyCardCategoriesLoading: false,
                loyaltyCardLoading: false,
                servicesLoading: false,
                customersLoading: false,
                customersDeletedLoading: false,
                ordersLoading: false,
                usageProductsLoading: false,
                checkDepositsLoading: false,
                suppliersLoading: false,
                imagesLoading: false,
                companyImagesLoading: false,
                daysLoading: false,
                resourceDays: [],
                resourceStartupDays: {},
                resourceOtherDays: {},
                loadSuccess: true,
                backOfficeRefLoading: false,
                backOfficeLoaded: false,
                loaded: false,
                appLoading: false,
                forceReload: false,
                securityError: false,
                reportsModelLoading: false,
                currencyLoading: false,
                companyMigrationSettingsLoading: false,
                newLoadingProgress: {
                    customers: false,
                    deletedCustomers: false,
                    startupLoadedDays: false,
                    allDays: false,
                },
                languageManagerLoading: false,
                unauthorizedUser: false,
                offerLoading: false
            };

            loader.loadBackOfficeDependencies = Decorators.timeMeasureDecorator(
                () => {
                    HumanResourceSrv.loadRef(CategoryData.categoryRoot);
                    PhysicalResourceSrv.loadRef(CategoryData.categoryRoot);
                    CategorySrv.loadRef();
                    ProductCategorySrv.loadRef();
                    ServiceSrv.loadRef();
                    ProductSrv.loadRef();
                    CureCategorySrv.loadRef();
                    CureSrv.loadRef();
                    LoyaltyCardCategorySrv.loadRef();
                    LoyaltyCardSrv.loadRef(useHashMapForApplicationLoading);
                    CompanySrv.loadRef();
                    OrderSrv.loadRef();
                    UsageProductSrv.loadRef();
                    loader.backOfficeLoaded = true;
                },
                TimeMeasures.BACKOFFICE_DEPENDENCIES_LOADING
            );

            loader.loadDaysDependencies = Decorators.timeMeasureDecorator(
                () => {
                    SaleSrv.loadRef(useHashMapForApplicationLoading);
                    BookingSrv.loadRef(useHashMapForApplicationLoading);
                    CureItemToServiceSrv.loadRef();
                    CureItemToServiceUsageSrv.loadRef(useHashMapForApplicationLoading);
                },
                TimeMeasures.DAYS_DEPENDENCIES_LOADING
            );

            loader.isCoreLoadingFinished = function () {
                return !loader.loggedUserLoading && !loader.storeAppLoading && !loader.appLoading && !loader.currencyLoading && !loader.companyMigrationSettingsLoading && !loader.vatsLoading && !loader.optsLoading && !loader.siteLoading
                    && !loader.humanResourcesLoading && !loader.physicalResourcesLoading && !loader.categoriesLoading && !loader.servicesLoading && !loader.productCategoriesLoading && !loader.productLoading
                    && !loader.cureCategoriesLoading && !loader.cureLoading && !loader.loyaltyCardCategoriesLoading && !loader.loyaltyCardLoading
                    && !loader.ordersLoading && !loader.usageProductsLoading && !loader.checkDepositsLoading && !loader.suppliersLoading && !loader.imagesLoading && !loader.companyImagesLoading
                    && !loader.reportsModelLoading && !loader.languageManagerLoading && !loader.offerLoading;
            }

            loader.newAfterLoad = function (success, successFunction, errorFunction, doneFunction) {
                loader.loadSuccess = loader.loadSuccess && success;

                // Light day load
                if (!this.daysLoading) {
                    this.daysLoading = true;
                    DaySrv.newLoadResourceDays(loader.resourceStartupDays, useHashMapForApplicationLoading);
                    loader.loadDaysDependencies();
                    loader.convertMapsToArrays(true, true);
                    loader.newLoadingProgress.startupLoadedDays = true;
                }

                if (!loader.customersDeletedLoading && !loader.newLoadingProgress.deletedCustomers) {
                    loader.newLoadingProgress.deletedCustomers = true;
                }

                if (!loader.customersLoading && !loader.newLoadingProgress.customers) {
                    loader.newLoadingProgress.customers = true;
                }

                if (loader.allDaysLoaded && !loader.customersDeletedLoading && !loader.customersLoading && loader.isCoreLoadingFinished()) {
                    loader.clearLightDaysData();
                    DaySrv.newLoadResourceDays(loader.resourceOtherDays, useHashMapForApplicationLoading, loader.resourceStartupDays);
                    loader.loadDaysDependencies();

                    AuditTrailSrv.createAndSave("80");

                    CustomerData.convertMapToArray(false, true);

                    loader.convertMapsToArrays(false, true);

                    loader.newLoadingProgress.allDays = true;

                    if (typeof doneFunction === "function") {
                        doneFunction();
                    }
                }

                if (!loader.loaded) {
                    if (loader.isCoreLoadingFinished() && loader.newLoadingProgress.startupLoadedDays) {
                        if (loader.loadSuccess) {
                            if (!loader.backOfficeLoaded && !loader.backOfficeRefLoading) {
                                MeasureStore.registerEnd(TimeMeasures.MODEL_LOADING);
                                loader.backOfficeRefLoading = true;
                                loader.loadBackOfficeDependencies();
                            }

                            if (loader.backOfficeLoaded) {
                                if (successFunction != undefined)
                                    successFunction();
                            }
                        } else {
                            if (errorFunction != undefined) {
                                errorFunction(loader.securityError, loader.unauthorizedUser);
                            }
                        }
                        loader.loaded = true;
                    }
                }

                if (loader.loaded && loader.allDaysLoaded && !loader.customersDeletedLoading && !loader.customersLoading) {
                    MeasureStore.registerEnd(TimeMeasures.AFTER_LOADING_STARTUP_REMAINING_TIME);
                    MonitoringSrv.logHealth(MonitoringApplication.PROBACKOFFICE, MonitoringHealthState.OK, JSON.stringify(MeasureStore));
                }
            };

            loader.clearLightDaysData = function () {
                DayData.clear();
                DayHrData.clear();
                DayPrData.clear();
                BookingData.clear();
                ActivityData.clear(true);
                SaleData.clear();
                SaleServiceData.clear();
                SaleProductData.clear();
                SaleCureData.clear();
                GiftItemData.clear();
                LoyaltyCardItemData.clear();
                CustomerData.clearBookingsAndSales();
                CheckDepositData.clearSalePayments();
            };

            loader.afterLoad = function (success, successFunction, errorFunction, doneFunction) {
                const canAccessNewLoading = LaunchDarklyFeatureFlagData.canAccessNewLoading;
                if (canAccessNewLoading) {
                    loader.newAfterLoad(success, successFunction, errorFunction, doneFunction);
                } else {
                    /*call everytime a resource is loaded : Can be called in parralel !
                    scenario 1 : all backoffice loaded before start of this function for dayloaded
                    scenario 2 : dayloaded before backoffice loaded at the start of the function
                    scenario 3 : all backoffice loading! (loadref) when function called by dayloaded*/
                    loader.loadSuccess = loader.loadSuccess && success;
                    if (loader.isCoreLoadingFinished() && !loader.customersLoading && !loader.customersDeletedLoading) {

                        if (loader.loadSuccess) {

                            if (!loader.backOfficeLoaded && !loader.backOfficeRefLoading) {
                                MeasureStore.registerEnd(TimeMeasures.MODEL_LOADING);
                                loader.backOfficeRefLoading = true;
                                loader.loadBackOfficeDependencies();
                            }

                            //If days loaded
                            if (!loader.daysLoading && loader.resourceDays && loader.backOfficeLoaded) {
                                DaySrv.loadResourceDays(loader.resourceDays, useHashMapForApplicationLoading);
                                loader.loadDaysDependencies();
                                AuditTrailSrv.createAndSave("80");

                                loader.convertMapsToArrays();
                                if (successFunction != undefined)
                                    successFunction();
                            }
                        } else {
                            if (errorFunction != undefined) {
                                errorFunction(loader.securityError, loader.unauthorizedUser);
                            }
                        }
                        loader.loaded = true;
                    }

                }
            };

            loader.load = function (successFunction, errorFunction, doneFunction) {
                const canAccessNewLoading = LaunchDarklyFeatureFlagData.canAccessNewLoading;

                MeasureStore.registerStart(TimeMeasures.MODEL_LOADING);
                if (loader.loaded) {
                    if (successFunction != undefined)
                        successFunction();
                    return;
                }

                if (loader.loggedUserLoading || loader.storeAppLoading || loader.appLoading || loader.currencyLoading || loader.companyMigrationSettingsLoading || loader.vatsLoading || loader.optsLoading || loader.siteLoading ||
                    loader.humanResourcesLoading || loader.physicalResourcesLoading || loader.categoriesLoading || loader.servicesLoading || loader.productCategoriesLoading || loader.productLoading ||
                    loader.cureCategoriesLoading || loader.cureLoading || loader.loyaltyCardCategoriesLoading || loader.loyaltyCardLoading || loader.customersLoading || loader.customersDeletedLoading ||
                    loader.ordersLoading || loader.usageProductsLoading || loader.checkDepositsLoading || loader.suppliersLoading || loader.imagesLoading || loader.companyImagesLoading ||
                    loader.reportsModelLoading || loader.daysLoading || loader.languageManagerLoading) {
                    // load already in process
                    return;
                }

                loader.allDaysLoaded = false;
                loader.loggedUserLoading = true;
                loader.storeAppLoading = true;
                loader.appLoading = true;
                loader.currencyLoading = true;
                loader.companyMigrationSettingsLoading = true;
                loader.vatLoading = true;
                loader.optsLoading = true;
                loader.siteLoading = true;
                loader.humanResourcesLoading = true;
                loader.physicalResourcesLoading = true;
                loader.categoriesLoading = true;
                loader.servicesLoading = true;
                loader.productCategoriesLoading = true;
                loader.productLoading = true;
                loader.cureCategoriesLoading = true;
                loader.cureLoading = true;
                loader.loyaltyCardCategoriesLoading = true;
                loader.loyaltyCardLoading = true;
                loader.customersLoading = true;
                loader.customersDeletedLoading = true;
                loader.ordersLoading = true;
                loader.usageProductsLoading = true;
                loader.checkDepositsLoading = true;
                loader.suppliersLoading = true;
                loader.imagesLoading = true;
                loader.companyImagesLoading = true;
                loader.reportsModelLoading = true;
                loader.daysLoading = true;
                loader.languageManagerLoading = true;
                loader.offerLoading = true;

                OfferService.findAll()
                    .then(function (data) {
                        OfferService.allOffers = data;
                        loader.offerLoading = false;
                        loader.afterLoad(true, successFunction, errorFunction, doneFunction);
                    })
                    .catch(function (error) {
                        if (error && error.status !== 200) {
                            loader.securityError = true;
                        }
                        loader.offerLoading = false;
                        loader.afterLoad(false, successFunction, errorFunction);
                    });

                UserSrv.loadLoggedUser(
                    function (user) {
                        loader.loggedUserLoading = false;
                        LanguageManager.initAcceptLanguage(user).then(
                            function () {
                                loader.languageManagerLoading = false;
                                loader.afterLoad(true, successFunction, errorFunction, doneFunction);
                            }, function () {
                                loader.languageManagerLoading = false;
                                loader.afterLoad(false, successFunction, errorFunction);
                            }
                        );
                    },
                    function (data) {
                        if (data && data.status == 403) {
                            loader.securityError = true;
                        }
                        if (data && data.status == 401 && (data.data && data.data.message === "AUTHORIZATION_FAILURE_COMPANY_TYPE_CANCELED")) {
                            loader.unauthorizedUser = true;
                        }
                        loader.loggedUserLoading = false;
                        loader.languageManagerLoading = false;
                        loader.afterLoad(false, successFunction, errorFunction);
                    }
                );

                StoreAppSrv.query(
                    function (data) {
                        loader.storeAppLoading = false;
                        loader.afterLoad(true, successFunction, errorFunction, doneFunction);
                    },
                    function (data) {
                        if (data && data.status == 403)
                            loader.securityError = true;
                        loader.storeAppLoading = false;
                        loader.afterLoad(false, successFunction, errorFunction);
                    }
                );

                AppSrv.query(
                    function (data) {
                        loader.appLoading = false;
                        loader.afterLoad(true, successFunction, errorFunction, doneFunction);
                    },
                    function (data) {
                        if (data && data.status == 403)
                            loader.securityError = true;
                        loader.appLoading = false;
                        loader.afterLoad(false, successFunction, errorFunction);
                    }
                );

                CompanyMigrationSettingsSrv.query(
                    function () {
                        loader.companyMigrationSettingsLoading = false;
                        loader.afterLoad(true, successFunction, errorFunction, doneFunction);
                    },
                    function (data) {
                        if (data && data.status == 403)
                            loader.securityError = true;
                        loader.companyMigrationSettingsLoading = false;
                        const success = data && data.status == 404 ? true : false;
                        loader.afterLoad(success, successFunction, errorFunction);
                    }
                );

                CurrencySrv.query(
                    //Success function after load
                    function (data) {
                        loader.currencyLoading = false;
                        loader.afterLoad(true, successFunction, errorFunction, doneFunction);
                    },
                    //Error function after load
                    function (data) {
                        if (data && data.status == 403)
                            loader.securityError = true;
                        loader.currencyLoading = false;
                        loader.afterLoad(false, successFunction, errorFunction);
                    }
                );

                VatSrv.query(
                    //Success function after load
                    function (data) {
                        loader.vatsLoading = false;
                        loader.afterLoad(true, successFunction, errorFunction, doneFunction);
                    },
                    //Error function after load
                    function (data) {
                        if (data && data.status == 403)
                            loader.securityError = true;
                        loader.vatsLoading = false;
                        loader.afterLoad(false, successFunction, errorFunction);
                    });

                OtherPaymentTypeSrv.query(
                    //Success function after load
                    function (data) {
                        loader.optsLoading = false;
                        loader.afterLoad(true, successFunction, errorFunction, doneFunction);
                    },
                    //Error function after load
                    function (data) {
                        if (data && data.status == 403)
                            loader.securityError = true;
                        loader.optsLoading = false;
                        loader.afterLoad(false, successFunction, errorFunction);
                    });

                SiteSrv.query(
                    //Success function after load
                    function (data) {
                        loader.siteLoading = false;
                        loader.afterLoad(true, successFunction, errorFunction, doneFunction);
                    },
                    //Error function after load
                    function (data) {
                        if (data && data.status == 403)
                            loader.securityError = true;
                        loader.siteLoading = false;
                        loader.afterLoad(false, successFunction, errorFunction);
                    }, useHashMapForApplicationLoading);

                HumanResourceSrv.query(
                    //Success function after load
                    function (data) {
                        loader.humanResourcesLoading = false;
                        loader.afterLoad(true, successFunction, errorFunction, doneFunction);
                    },
                    //Error function after load
                    function (data) {
                        if (data && data.status == 403)
                            loader.securityError = true;
                        loader.humanResourcesLoading = false;
                        loader.afterLoad(false, successFunction, errorFunction);
                    });

                PhysicalResourceSrv.query(
                    //Success function after load
                    function (humanResources) {
                        loader.physicalResourcesLoading = false;
                        loader.afterLoad(true, successFunction, errorFunction, doneFunction);
                    },
                    //Error function after load
                    function (data) {
                        if (data && data.status == 403)
                            loader.securityError = true;
                        loader.physicalResourcesLoading = false;
                        loader.afterLoad(false, successFunction, errorFunction);
                    });

                CategorySrv.query(
                    //Success function after load
                    function (data) {
                        loader.categoriesLoading = false;
                        loader.afterLoad(true, successFunction, errorFunction, doneFunction);
                    },
                    //Error function after load
                    function (data) {
                        if (data && data.status == 403)
                            loader.securityError = true;
                        loader.categoriesLoading = false;
                        loader.afterLoad(false, successFunction, errorFunction);
                    });

                ServiceSrv.query(
                    //Success function after load
                    function (data) {
                        loader.servicesLoading = false;
                        loader.afterLoad(true, successFunction, errorFunction, doneFunction);
                    },
                    //Error function after load
                    function (data) {
                        if (data && data.status == 403)
                            loader.securityError = true;
                        loader.servicesLoading = false;
                        loader.afterLoad(false, successFunction, errorFunction);
                    });

                ProductCategorySrv.query(
                    //Success function after load
                    function (data) {
                        loader.productCategoriesLoading = false;
                        loader.afterLoad(true, successFunction, errorFunction, doneFunction);
                    },
                    //Error function after load
                    function (data) {
                        if (data && data.status == 403)
                            loader.securityError = true;
                        loader.productCategoriesLoading = false;
                        loader.afterLoad(false, successFunction, errorFunction);
                    });

                ProductSrv.query(
                    //Success function after load
                    function (data) {
                        loader.productLoading = false;
                        loader.afterLoad(true, successFunction, errorFunction, doneFunction);
                    },
                    //Error function after load
                    function (data) {
                        if (data && data.status == 403)
                            loader.securityError = true;
                        loader.productLoading = false;
                        loader.afterLoad(false, successFunction, errorFunction);
                    });

                CureCategorySrv.query(
                    //Success function after load
                    function (data) {
                        loader.cureCategoriesLoading = false;
                        loader.afterLoad(true, successFunction, errorFunction, doneFunction);
                    },
                    //Error function after load
                    function (data) {
                        if (data && data.status == 403)
                            loader.securityError = true;
                        loader.cureCategoriesLoading = false;
                        loader.afterLoad(false, successFunction, errorFunction);
                    });

                CureSrv.query(
                    //Success function after load
                    function (data) {
                        loader.cureLoading = false;
                        loader.afterLoad(true, successFunction, errorFunction, doneFunction);
                    },
                    //Error function after load
                    function (data) {
                        if (data && data.status == 403)
                            loader.securityError = true;
                        loader.cureLoading = false;
                        loader.afterLoad(false, successFunction, errorFunction);
                    });

                LoyaltyCardCategorySrv.query(
                    //Success function after load
                    function (data) {
                        loader.loyaltyCardCategoriesLoading = false;
                        loader.afterLoad(true, successFunction, errorFunction, doneFunction);
                    },
                    //Error function after load
                    function (data) {
                        if (data && data.status == 403)
                            loader.securityError = true;
                        loader.loyaltyCardCategoriesLoading = false;
                        loader.afterLoad(false, successFunction, errorFunction);
                    });

                LoyaltyCardSrv.query(
                    //Success function after load
                    function (data) {
                        loader.loyaltyCardLoading = false;
                        loader.afterLoad(true, successFunction, errorFunction, doneFunction);
                    },
                    //Error function after load
                    function (data) {
                        if (data && data.status == 403)
                            loader.securityError = true;
                        loader.loyaltyCardLoading = false;
                        loader.afterLoad(false, successFunction, errorFunction);
                    });

                if (!canAccessNewLoading) {
                    CustomerData.clear();
                    CustomerSrv.loadCustomers(useHashMapForApplicationLoading).then(
                        () => {
                            loader.customersLoading = false;
                            loader.afterLoad(true, successFunction, errorFunction);
                        },
                        data => {
                            if (data && data.status == 403)
                                loader.securityError = true;
                            loader.customersLoading = false;
                            loader.afterLoad(false, successFunction, errorFunction);
                        }
                    );

                    CustomerSrv.loadDeletedCustomersMaster(null, useHashMapForApplicationLoading).then(
                        () => {
                            loader.customersDeletedLoading = false;
                            loader.afterLoad(true, successFunction, errorFunction);
                        },
                        data => {
                            if (data && data.status == 403)
                                loader.securityError = true;
                            loader.customersDeletedLoading = false;
                            loader.afterLoad(true, successFunction, errorFunction);
                        }
                    );
                }

                OrderSrv.query(
                    //Success function after load
                    function (data) {
                        loader.ordersLoading = false;
                        loader.afterLoad(true, successFunction, errorFunction, doneFunction);
                    },
                    //Error function after load
                    function (data) {
                        if (data && data.status == 403)
                            loader.securityError = true;
                        loader.ordersLoading = false;
                        loader.afterLoad(false, successFunction, errorFunction);
                    });

                UsageProductSrv.query(
                    //Success function after load
                    function (data) {
                        loader.usageProductsLoading = false;
                        loader.afterLoad(true, successFunction, errorFunction, doneFunction);
                    },
                    //Error function after load
                    function (data) {
                        if (data && data.status == 403)
                            loader.securityError = true;
                        loader.usageProductsLoading = false;
                        loader.afterLoad(false, successFunction, errorFunction);
                    });

                CheckDepositSrv.query(
                    //Success function after load
                    function (data) {
                        loader.checkDepositsLoading = false;
                        loader.afterLoad(true, successFunction, errorFunction, doneFunction);
                    },
                    //Error function after load
                    function (data) {
                        if (data && data.status == 403)
                            loader.securityError = true;
                        loader.checkDepositsLoading = false;
                        loader.afterLoad(false, successFunction, errorFunction);
                    });

                SupplierSrv.query(
                    //Success function after load
                    function (data) {
                        loader.suppliersLoading = false;
                        loader.afterLoad(true, successFunction, errorFunction, doneFunction);
                    },
                    //Error function after load
                    function (data) {
                        if (data && data.status == 403)
                            loader.securityError = true;
                        loader.suppliersLoading = false;
                        loader.afterLoad(false, successFunction, errorFunction);
                    });
                ImageSrv.query(
                    //Success function after load
                    function (data) {
                        loader.imagesLoading = false;
                        loader.afterLoad(true, successFunction, errorFunction, doneFunction);
                    },
                    //Error function after load
                    function (data) {
                        if (data && data.status == 403)
                            loader.securityError = true;
                        loader.imagesLoading = false;
                        loader.afterLoad(false, successFunction, errorFunction);
                    });

                CompanyImageSrv.query(
                    //Success function after load
                    function (data) {
                        loader.companyImagesLoading = false;
                        loader.afterLoad(true, successFunction, errorFunction, doneFunction);
                    },
                    //Error function after load
                    function (data) {
                        if (data && data.status == 403)
                            loader.securityError = true;
                        loader.companyImagesLoading = false;
                        loader.afterLoad(false, successFunction, errorFunction);
                    });

                ReportModelSrv.query(
                    //Success function after load
                    function (data) {
                        loader.reportsModelLoading = false;
                        loader.afterLoad(true, successFunction, errorFunction, doneFunction);
                    },
                    //Error function after load
                    function (data) {
                        if (data && data.status == 403)
                            loader.securityError = true;
                        loader.reportsModelLoading = false;
                        loader.afterLoad(false, successFunction, errorFunction);
                    });

                if (canAccessNewLoading) {
                    DaySrv.listDaysId().then((daysId) => {
                        const nbSecondsInDay = Constants.SECONDS_IN_A_DAY;
                        const now = Date.now();
                        const firstStartupLoadedDay = DaySrv.getIdFromDate(new Date((now - (Constants.NB_STARTUP_LOADED_DAYS * nbSecondsInDay))));
                        const lastStartupLoadedDay = DaySrv.getIdFromDate(new Date((now + (Constants.NB_STARTUP_LOADED_DAYS * nbSecondsInDay))));

                        let startupLoadedDayIds = [...new Set([
                            firstStartupLoadedDay,
                            ...daysId.filter((id) => {
                                return id > firstStartupLoadedDay && id < lastStartupLoadedDay;
                            }),
                            lastStartupLoadedDay,
                        ])];

                        loader.newLoadDaysMaster(startupLoadedDayIds, (loaders) =>
                            loader.resourceStartupDays = loader.newFinalizeDaysLoading(loaders)).then(() => {
                                loader.daysLoading = false;
                                loader.afterLoad(true, successFunction, errorFunction, doneFunction);
                            },
                            (error) => {
                                console.log(error);
                                loader.afterLoad(false, successFunction, errorFunction);
                            });

                        loader.newLoadDaysMaster(daysId, (loaders) =>
                            loader.resourceOtherDays = loader.newFinalizeDaysLoading(loaders)).then(() => {
                            loader.allDaysLoaded = true;
                            loader.afterLoad(true, successFunction, errorFunction, doneFunction);
                        }, (error) => {
                            console.log(error);
                            loader.afterLoad(false, successFunction, errorFunction);
                        });

                        CustomerSrv.loadCustomers(useHashMapForApplicationLoading).then(
                            () => {
                                loader.customersLoading = false;
                                loader.afterLoad(true, successFunction, errorFunction, doneFunction);
                            },
                            data => {
                                if (data && data.status === 403) {
                                    loader.securityError = true;
                                }
                                loader.customersLoading = false;
                                loader.afterLoad(false, successFunction, errorFunction);
                            }
                        );

                        CustomerSrv.loadDeletedCustomersMaster(null, useHashMapForApplicationLoading).then(
                            () => {
                                loader.customersDeletedLoading = false;
                                loader.afterLoad(true, successFunction, errorFunction, doneFunction);
                            },
                            data => {
                                if (data && data.status === 403) {
                                    loader.securityError = true;
                                }
                                loader.customersDeletedLoading = false;
                                loader.afterLoad(true, successFunction, errorFunction);
                            }
                        );
                    });
                } else {
                    loader.loadDaysMaster().then(
                        () => {
                            loader.afterLoad(true, successFunction, errorFunction);
                        },
                        (error) => {
                            loader.afterLoad(false, successFunction, errorFunction);
                        });
                }
            };

            loader.newLoadDaysMaster = function (daysId, finalizeLoadingFunction) {
                let end;
                let promises = [];
                let loaders = LoaderUtil.computeLoaders(daysId);
                for (let i = 0; i < loaders.length; i++) {
                    end = loaders[i].daysId[loaders[i].daysId.length - 1];
                    promises.push(loader.newLoadDays(loaders[i], loaders[i].daysId[0], end));
                }
                return Promise.all(promises).then(
                    () => {
                        if (finalizeLoadingFunction) {
                            finalizeLoadingFunction(loaders);
                        }
                    },
                    (error) => {
                        throw error;
                    }
                );
            };

            loader.loadDaysMaster = Decorators.timeMeasureDecorator(
                () => {
                    return DaySrv.listDaysId().then(
                        (daysId) => {
                            let loaders = [{loading: true, daysId: [], days: []}];
                            let j = 0;
                            let size = 122;//3 by year

                            for (let i = 0; i < daysId.length; i++) {
                                if (!isNaN(daysId[i]) && daysId[i] > 20000000) {
                                    loaders[j].daysId.push(daysId[i]);
                                }

                                if (((i + 1) % size === 0) && ((i + 1) < daysId.length)) {
                                    loaders.push({loading: true, daysId: [], days: []});
                                    j++;
                                }
                            }

                            let end;
                            let promises = [];
                            for (let i = 0; i < loaders.length; i++) {
                                if (i === loaders.length - 1) {//last query get all
                                    end = 30000101;
                                } else {
                                    end = loaders[i].daysId[loaders[i].daysId.length - 1];
                                }
                                promises.push(loader.loadDays(loaders[i], loaders[i].daysId[0], end));
                            }
                            return Promise.all(promises).then(
                                () => {
                                    loader.daysLoading = false;
                                    loader.finalizeLoading(loaders);
                                },
                                (error) => {
                                    loader.daysLoading = false;
                                    throw error;
                                }
                            );
                        },
                        (error) => {
                            if (error && error.status == 403)
                                loader.securityError = true;
                            loader.daysLoading = false;
                        }
                    );
                },
                TimeMeasures.DAYS_LOADING
            );

            loader.finalizeLoading = function (loaders) {
                for (let i = 0; i < loaders.length; i++) {
                    loader.resourceDays = loader.resourceDays.concat(loaders[i].days);
                }
            };

            loader.newFinalizeDaysLoading = function (loaders) {
                let dayResources = [];
                for (let i = 0; i < loaders.length; i++) {
                    dayResources = dayResources.concat(loaders[i].days);
                }
                dayResources = dayResources.sort((day1, day2) => day1.id - day2.id)

                let dayResourceByDayId = [];
                for (let i = 0; i < dayResources.length; i++) {
                    dayResourceByDayId[dayResources[i].id] = dayResources[i];
                }

                return dayResourceByDayId;
            };

            loader.newLoadDays = function (loaderObject, startDayId, endDayId) {
                if (window.Worker) {
                    return new Promise((resolve) => {
                        const token = $http.defaults.headers.common.Authorization;
                        let baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";

                        const url = (baseUrl + `rest/days/${startDayId}/${endDayId}`);
                        try {
                            let daysWorker = new Worker('/dist/workers/days.worker.js');
                            daysWorker.postMessage([url, token]);

                            daysWorker.onmessage = function (e) {
                                const result = e.data;
                                loaderObject.days = loaderObject.days.concat(result.days);

                                daysWorker.terminate();
                                if (result.stillDayToLoad && result.days && result.days.length > 0) {
                                    loaderObject.loading = true;
                                    let lastDate = DaySrv.getDateFromId(result.days[result.days.length - 1].id);
                                    lastDate.setDate(lastDate.getDate() + 1);
                                    let newStartDayId = DaySrv.getIdFromDate(lastDate);
                                    return resolve(loader.newLoadDays(loaderObject, newStartDayId, endDayId));
                                }
                                loaderObject.loading = false;
                                return resolve();
                            }
                        } catch (e) {
                            if (window.bugsnag) {
                                bugsnag.notify("Loader.js - failed to create days worker", "", {}, Constants.BUGSNAG_NOTIFICATION_LEVEL);
                            }
                            return loader.loadDays(loaderObject, startDayId, endDayId);
                        }
                    })
                } else {
                    return loader.loadDays(loaderObject, startDayId, endDayId);
                }
            };

            loader.loadDays = function (loaderObj, startDayId, endDayId) {
                return DaySrv.queryBasedDays(startDayId, endDayId).then(
                    (data) => {
                        if (data && data.stillDayToLoad && data.days && data.days.length > 0) {
                            MeasureStore.registerCount(CountMeasures.NUMBER_STILL_DAY_TO_LOAD);
                            loaderObj.days = loaderObj.days.concat(data.days);
                            let lastDate = DaySrv.getDateFromId(data.days[data.days.length - 1].id);
                            lastDate.setDate(lastDate.getDate() + 1);
                            let lastId = DaySrv.getIdFromDate(lastDate);
                            return loader.loadDays(loaderObj, lastId, endDayId);
                        } else {
                            loaderObj.days = loaderObj.days.concat(data.days);
                            loaderObj.loading = false;
                        }
                    },
                    //Error function after load
                    (error) => {
                        if (error && error.status == 403)
                            loader.securityError = true;
                        throw new Error("Error during days loading, startId : " + startDayId + " endId : " + endDayId);
                    }
                );
            };
            //FIXME : not used, need to be delete
            loader.loadProSiteData = function (proSiteData, successFunction, errorFunction) {
                SiteData.sites.push(new Site(proSiteData.defaultSite));
                if (SiteData.sites.length > 0)
                    SiteData.defaultSite = SiteData.sites[0];

                if (proSiteData.humanResources)
                    for (var i = 0; i < proSiteData.humanResources.length; i++)
                        new HumanResource(proSiteData.humanResources[i]);//auto register to DATA

                if (proSiteData.physicalResources)
                    for (var i = 0; i < proSiteData.physicalResources.length; i++)
                        new PhysicalResource(proSiteData.physicalResources[i]);//auto register to DATA

                CategoryData.categoryRoot = new Category(proSiteData.categoryRoot);

                if (proSiteData.images)
                    for (var i = 0; i < proSiteData.images.length; i++)
                        ImageData.add(new Image(proSiteData.images[i]));

                if (proSiteData.companyImages)
                    for (var i = 0; i < proSiteData.companyImages.length; i++)
                        CompanyImageData.add(new CompanyImage(proSiteData.companyImages[i]));

                if (proSiteData.apps)
                    for (var i = 0; i < proSiteData.apps.length; i++)
                        new App(proSiteData.apps[i]);

                HumanResourceSrv.loadRef(CategoryData.categoryRoot);
                PhysicalResourceSrv.loadRef(CategoryData.categoryRoot);
                CategorySrv.loadRef();
                ServiceSrv.loadRef();
                if (proSiteData.queryDays && proSiteData.queryDays.days)
                    DaySrv.loadResourceDays(proSiteData.queryDays.days);
                else
                    DaySrv.loadResourceDays([]);
                if (successFunction != undefined)
                    successFunction();
            };

            loader.loadWebData = function (webData, successFunction, errorFunction) {
                SiteData.sites.push(new Site(webData.defaultSite));
                if (SiteData.sites.length > 0)
                    SiteData.defaultSite = SiteData.sites[0];

                if (webData.humanResources)
                    for (var i = 0; i < webData.humanResources.length; i++)
                        new HumanResource(webData.humanResources[i]);//auto register to DATA

                if (webData.physicalResources)
                    for (var i = 0; i < webData.physicalResources.length; i++)
                        new PhysicalResource(webData.physicalResources[i]);//auto register to DATA

                CategoryData.categoryRoot = new Category(webData.categoryRoot);
                ProductCategoryData.categoryRoot = new ProductCategory(webData.productCategoryRoot);
                CureCategoryData.categoryRoot = new CureCategory(webData.cureCategoryRoot);
                LoyaltyCardCategoryData.categoryRoot = new LoyaltyCardCategory(webData.loyaltyCardCategoryRoot);

                if (webData.customersPost)
                    for (var i = 0; i < webData.customersPost.length; i++)
                        CustomerPostData.add(new CustomerPost(webData.customersPost[i]));

                if (webData.images)
                    for (var i = 0; i < webData.images.length; i++)
                        ImageData.add(new Image(webData.images[i]));

                if (webData.companyImages)
                    for (var i = 0; i < webData.companyImages.length; i++)
                        CompanyImageData.add(new CompanyImage(webData.companyImages[i]));

                if (webData.apps)
                    for (var i = 0; i < webData.apps.length; i++)
                        new App(webData.apps[i]);

                if (webData.vats)
                    for (var i = 0; i < webData.vats.length; i++)
                        new Vat(webData.vats[i]);

                if (successFunction != undefined)
                    $timeout(function () {
                        HumanResourceSrv.loadRef(CategoryData.categoryRoot);
                        PhysicalResourceSrv.loadRef(CategoryData.categoryRoot);
                        CategorySrv.loadRef();
                        ServiceSrv.loadRef();
                        ProductCategorySrv.loadRef();
                        CureCategorySrv.loadRef();
                        LoyaltyCardCategorySrv.loadRef();
                        ProductSrv.loadRef();
                        CureSrv.loadRef();
                        CureItemToServiceSrv.loadRef();
                        LoyaltyCardSrv.loadRef();
                        if (successFunction != undefined)
                            successFunction();
                    });

            };

            loader.convertMapsToArrays = function (keepObject, canAccessNewLoading) {
                if (!canAccessNewLoading) {
                    CustomerData.convertMapToArray();
                }
                SaleData.convertMapToArray(keepObject, canAccessNewLoading);
                BookingData.convertMapToArray(keepObject, canAccessNewLoading);
                DayData.convertMapToArray(keepObject, canAccessNewLoading);
                ActivityData.convertMapToArray(keepObject, canAccessNewLoading);
            };

            return loader;
        }]);

angular.module('FlexyBeautyApp.services')
    .factory('LoaderUtil', [function () {
        let loaderUtil = {};
        loaderUtil.LOADER_SIZE = 122;

        loaderUtil.computeLoaders = function (daysId) {
            let loaders = [];
            if (daysId.length > 0) {
                loaders.push({loading: true, daysId: [], days: []});
                let j = 0;

                for (let i = 0; i < daysId.length; i++) {
                    if (!isNaN(daysId[i]) && daysId[i] > 20000000) {
                        loaders[j].daysId.push(daysId[i]);
                    }

                    if (((i + 1) % loaderUtil.LOADER_SIZE === 0) && ((i + 1) < daysId.length)) {
                        loaders.push({loading: true, daysId: [], days: []});
                        j++;
                    }
                }
            }
            return loaders;
        }
        return loaderUtil;
    }]);



// WEBPACK FOOTER //
// ./js/services/tools/Loader.js